import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {paragraphObjectBackground} from "../../helpers/graphQLShortcuts";
import './SideLabel.scss';

interface Data {
    paragraphById: {
        fieldColorText: string;
        fieldTxtHeadline: string;
        fieldColorBackground: string;
        fieldRightOrLeftAlignment: string;
        fieldSideLabelBackground: Array<{}>;
    }
}

class SideLabelQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentSideLabel {
          fieldColorText
          fieldTxtHeadline
          fieldColorBackground
          fieldSideLabelBackground {
              entity {
                ... on Paragraph {
                  ${paragraphObjectBackground}
                }  
            }
          }
          fieldRightOrLeftAlignment
        }
      }
    }
  }
}
`;


const SideLabel = ({id, markComponentLoadedAs}) => (
    <SideLabelQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.paragraphById) {
                markComponentLoadedAs(id, true);
                return <div>{error || null}</div>;
            }

            const field = data.paragraphById;

            // Generate Styles Object
            const styles = fieldObjectSectionStyleCss({
                entity: {
                    fieldObjectBackground: field.fieldSideLabelBackground
                }
            });

            if (field.fieldRightOrLeftAlignment && field.fieldRightOrLeftAlignment === 'right') {
                styles.classNames += ' sideLabel--right';
            } else {
                styles.classNames += ' sideLabel--left';
            }

            markComponentLoadedAs(id, true);

            return (
                <div className={`sideLabel${styles.classNames}`} style={styles.css}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    <div className="sideLabel__filler sideLabel__filler--left" style={{borderTop: `1px solid ${field.fieldColorBackground}`}}/>
                    <div className="sideLabel__banner"
                         style={{
                             backgroundColor: field.fieldColorBackground,
                             color: field.fieldColorText
                         }}>
                        {field.fieldTxtHeadline}
                    </div>
                    <div className="sideLabel__filler sideLabel__filler--right" style={{borderTop: `1px solid ${field.fieldColorBackground}`}}/>
                </div>
            );
        }}
    </SideLabelQuery>
);

SideLabel.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default SideLabel;



// WEBPACK FOOTER //
// ./frontend/components/SideLabel/SideLabel.jsx